export const IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
export const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const IS_IMAGE = /\.(gif|jpg|jpeg|tiff|png)($|\?)/i;
export const VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
export const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
export const HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/VERSION/hls.min.js';
export const HLS_GLOBAL = 'Hls';
export const DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
export const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
